class Licensecheck {
    constructor() {
        /** @type {HTMLBodyElement} */
        this.bodyElem = document.body;

        /** @type {string} */
        this.rootUrl = this.bodyElem.dataset.root;

        /** @type {int} */
        this.typenum = 167284;

        this.checkLicense();
    }

    checkLicense() {
        const checkUrl = new URL(this.rootUrl);
        checkUrl.searchParams.set('type', this.typenum);

        fetch(checkUrl)
        .then(res => res.json())
        .then(json => {
            if (!json['valid']) {
                this.bodyElem.innerHTML = "<p>This website is using an unlicensed version of OM Evergreen PRO.</p>";
            }
        });
    }
}

setTimeout(() => new Licensecheck(), 5000);

export default Licensecheck;
